export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'UPDATE_TAG_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'UPDATE_TAG_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'UPDATE_TAG_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
